<template>
  <div class="attrList">
    <div class="myicon"><i class="iconfont icon-sanjiaoxingshang"></i></div>
    <div class="box" v-loading="showView">
      <!-- 表单数据 -->
      <el-form class="com_el_form" ref="form" :model="formDataGoods" label-width="80px" label-position="left">
        <el-form-item class="attr_scroll" v-for="(attr,attrKey,attrIndex) in attrInfo" :key="attrIndex" :label="attr.name">
          <div class="attr_type" v-show="attr.specialType == 0">
            <el-tooltip :open-delay="500" :visible-arrow="false" effect="light" :offset="-10" :content="item.name" placement="top-end" v-for="(item,index) in attr.contentList" :key="index">
              <button :disabled="item.isDisabled" type="button" class="group" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">{{item.name}}</button>
            </el-tooltip>
          </div>
          <div class="attr_type" v-show="attr.specialType == 1">
            <el-tooltip effect="light" :visible-arrow="false" :open-delay="500" :offset="-30" :content="item.name" placement="top-end" v-for="(item,index) in attr.contentList" :key="index">
              <button :disabled="item.isDisabled" type="button" class="color_img" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">
                <img v-lazy="item.filePath" alt />
              </button>
            </el-tooltip>
          </div>
          <div class="attr_type" v-show="attr.specialType == 2">
            <el-tooltip :open-delay="500" :visible-arrow="false" effect="light" :offset="-30" :content="item.name" placement="top-end" v-for="(item,index) in attr.contentList" :key="index">
              <button :disabled="item.isDisabled" type="button" class="color_img" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">
                <div class="bc_box" :style="{backgroundColor: item.colorRGB}"></div>
              </button>
            </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
      <div class="btn_box">
        <el-button type="primary" class="btn" :loading='loading' @click="confirm">确定</el-button>
        <el-button type="info" class="btn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetGoodsMixBasicInfo } from "@/pages/page1/api/modules/goods";
import { GetShopCartList, UpdateShopCart } from "@/pages/page1/api/modules/shoppingCart";
export default {
  name: "attrList",
  data() {
    return {
      formDataGoods: {},
      attrInfo: {
        attr1Info: {},
        attr2Info: {},
        attr3Info: {},
        attr4Info: {},
      },
      attrNumber: 0,
      resData: undefined,
      goodsMixId: undefined,
      shopCartId: undefined,
      loading: false,
      showView: false,
      shoppingCartBrandList: [],
      mixSerNo: undefined,
    };
  },
  methods: {
    getGoodsBaseInfo(serNo, id) {
      // 下一次打开一样的花，不请求
      if (this.mixSerNo == serNo) {
        return;
      }
      this.mixSerNo = serNo;
      this.shopCartId = id;
      let params = {
        mixId: null,
        mixSerNo: serNo,
      };
      this.showView = true;
      this.attrNumber = 0;
      GetGoodsMixBasicInfo(params)
        .then((res) => {
          // console.log("获取某个商品信息", res);
          let data = res.data[0];
          // 保存原始数据
          this.resData = data;
          // 四个属性
          if (data.attrs.attr1Info) {
            this.actionAttr(data, "attr1Info");
            this.attrNumber += 1;
          }
          if (data.attrs.attr2Info) {
            this.actionAttr(data, "attr2Info");
            this.attrNumber += 1;
          }
          if (data.attrs.attr3Info) {
            this.actionAttr(data, "attr3Info");
            this.attrNumber += 1;
          }
          if (data.attrs.attr4Info) {
            this.actionAttr(data, "attr4Info");
            this.attrNumber += 1;
          }
          // 初始化使用mixId相同的组合（就是商品编号的数据）
          let initialMix = data.mixs.find((v) => data.mixId == v.id);
          this.attrInfo.attr1Info.currentId = initialMix.attr1ContentId;
          this.attrInfo.attr2Info.currentId = initialMix.attr2ContentId;
          this.attrInfo.attr3Info.currentId = initialMix.attr3ContentId;
          this.attrInfo.attr4Info.currentId = initialMix.attr4ContentId;
          // 当前组合id
          this.goodsMixId = initialMix.id;
          // 找到不存在的，不能点击
          this.findDisabled();
          this.getShoppingCart();
        })
        .catch((err) => {
          this.showView = false;
        });
    },
    getShoppingCart() {
      GetShopCartList({})
        .then((res) => {
          this.shoppingCartBrandList = res.data;
          this.showView = false;
        })
        .catch((err) => {
          this.showView = false;
        });
    },
    confirm() {
      let canUpDate = true;
      let isOldGoods = false;
      this.shoppingCartBrandList.forEach((item) => {
        item.shoppingCartList.forEach((v) => {
          // 去购物车查看是否有相同的商品
          if (v.goodsMixId === this.goodsMixId && v.id != this.shopCartId) {
            canUpDate = false;
          }
          // 如果是原商品
          if (v.goodsMixId === this.goodsMixId && v.id === this.shopCartId) {
            isOldGoods = true;
          }
        });
      });
      if (isOldGoods) {
        this.cancel();
        return;
      }
      if (!canUpDate) {
        this.$confirm("该商品已加购, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.update();
          })
          .catch(() => {
            this.cancel();
          });
      } else {
        this.update();
      }
    },
    cancel() {
      this.$emit("closeAttr", false);
    },
    update() {
      let params = {
        goodsMixId: this.goodsMixId,
        id: this.shopCartId,
      };
      this.loading = true;
      // 修改购物记录的商品组合
      UpdateShopCart(params)
        .then((res) => {
          // console.log("修改购物车记录", res);
          this.loading = false;
          this.$emit("closeAttr", true);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // change四个属性
    changeAttr(item, attr) {
      // 选中
      attr.currentId = item.id;
      let resItem = this.resData.mixs.find(
        (v) =>
          v.attr1ContentId == this.attrInfo.attr1Info.currentId &&
          v.attr2ContentId == this.attrInfo.attr2Info.currentId &&
          v.attr3ContentId == this.attrInfo.attr3Info.currentId &&
          v.attr4ContentId == this.attrInfo.attr4Info.currentId
      );
      this.goodsMixId = resItem.id;
      this.findDisabled();
    },
    findDisabled() {
      switch (this.attrNumber) {
        case 1:
          this.forEachAttr1();
          break;
        case 2:
          this.forEachAttr1();
          this.forEachAttr2();
          break;
        case 3:
          this.forEachAttr1();
          this.forEachAttr2();
          this.forEachAttr3();
          break;
        case 4:
          this.forEachAttr1();
          this.forEachAttr2();
          this.forEachAttr3();
          this.forEachAttr4();
          break;
        default:
          break;
      }
    },
    forEachAttr1() {
      this.attrInfo.attr1Info.contentList.forEach((v) => {
        let result = this.resData.mixs.find((item) => {
          return (
            item.attr1ContentId == v.id &&
            item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
            item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
            item.attr4ContentId == this.attrInfo.attr4Info.currentId
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    forEachAttr2() {
      this.attrInfo.attr2Info.contentList.forEach((v) => {
        let result = this.resData.mixs.find((item) => {
          return (
            item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
            item.attr2ContentId == v.id &&
            item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
            item.attr4ContentId == this.attrInfo.attr4Info.currentId
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    forEachAttr3() {
      this.attrInfo.attr3Info.contentList.forEach((v) => {
        let result = this.resData.mixs.find((item) => {
          return (
            item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
            item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
            item.attr3ContentId == v.id &&
            item.attr4ContentId == this.attrInfo.attr4Info.currentId
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    forEachAttr4() {
      this.attrInfo.attr4Info.contentList.forEach((v) => {
        let result = this.resData.mixs.find((item) => {
          return (
            item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
            item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
            item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
            item.attr4ContentId == v.id
          );
        });
        v.isDisabled = false;
        if (!result) {
          v.isDisabled = true;
        }
      });
    },
    actionAttr(data, attr) {
      data.attrs[attr].contentList.sort(this.compare("sortOrder"));
      data.attrs[attr].contentList.forEach((v) => {
        this.$set(v, "isDisabled", false);
      });
      this.attrInfo[attr] = data.attrs[attr];
      this.$set(this.attrInfo[attr], "currentId", null);
    },
    compare(propertyName) {
      //根据哪个属性值排序
      return function (obj1, obj2) {
        //对象两两比较 升序
        let value1 = obj1[propertyName];
        let value2 = obj2[propertyName];
        return value1 - value2;
      };
    },
  },
};
</script>

<style lang="less" scoped>
.attrList {
  position: relative;
  width: 400px;
  .box {
    border: 1px solid #d9d9d9;
    padding: 20px 10px;
    padding-bottom: 40px;
    min-height: 140px;
    box-sizing: border-box;
    z-index: 1;
    position: relative;
    .btn_box {
      position: absolute;
      bottom: 10px;
      left: 0;
      text-align: center;
      width: 100%;
      .btn {
        height: 24px;
        font-size: 12px;
        padding: 0 10px;
        text-align: center;
        line-height: 24px;
        border-radius: 0px;
      }
    }
  }
  .myicon {
    position: absolute;
    left: 33px;
    top: -8px;
    width: 18px;
    height: 9px;
    line-height: 9px;
    display: block;
    background-position: 0 0;
    background-color: #fff;
    z-index: 2;
  }
}
</style>